import { useEffect, useState } from 'react';

import {
  clearLegalAgreementRequired,
  getLegalAgreementRequired,
  subscribeLegalAgreementRequired,
} from '../api/legalAgreementGate';

/** Подписка на принудительное открытие LegalAgreementModal (после 403 гейта). */
export function useLegalAgreementGate(): {
  required: boolean;
  clear: () => void;
} {
  const [required, setRequired] = useState(getLegalAgreementRequired);

  useEffect(() => {
    return subscribeLegalAgreementRequired(() => {
      setRequired(getLegalAgreementRequired());
    });
  }, []);

  return {
    required,
    clear: clearLegalAgreementRequired,
  };
}
